import { styled } from '@mui/material/styles';

import { CloseIcon } from '@assets/icons/close.tsx';

export type Variant = 'default' | 'profile' | 'rich' | 'course';
export const StyledFieldLabel = styled('label')<{
  imgUrl: string | null;
  $active: boolean;
  disabled: boolean;
  hasError: boolean;
  variant: Variant;
}>(({ theme, imgUrl, $active, disabled, hasError, variant }) => ({
  position: 'relative',
  width: '112px',
  height: '112px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: $active ? theme.palette.accent : theme.palette.light_dark,
  objectFit: 'cover',
  background: imgUrl ? `url(${imgUrl})` : theme.palette.white_100,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: '50%',
  cursor: disabled ? 'default' : 'pointer',
  opacity: disabled ? 0.7 : 1,
  outline: imgUrl ? undefined : `1px solid ${theme.palette.pale_accent}`,
  '&:hover': {
    ...(!disabled && {
      color: theme.palette.accent,
      outline: `1px solid ${theme.palette.accent}`,
      background: imgUrl
        ? `linear-gradient(0deg, var(--Black-50, rgba(0, 0, 0, 0.50)) 0%, var(--Black-50, rgba(0, 0, 0, 0.50)) 100%), url(${imgUrl}) lightgray -77.395px -11.878px / 193.016% 193.016% no-repeat`
        : theme.palette.white_100,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }),
  },

  ...(hasError && {
    color: theme.palette.error.main,
    outline: `1px solid ${theme.palette.error.main}`,
  }),

  ...(variant === 'profile' && {
    width: '180px',
    height: '180px',
    borderRadius: 16,
  }),

  ...(variant === 'course' && {
    width: '403px',
    maxWidth: '100%',
    height: '221.221px',
    borderRadius: 16,
    background: imgUrl ? `url(${imgUrl})` : theme.palette.bgDark,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    outline: imgUrl ? undefined : 'none',
    '&:hover': {
      ...(!disabled && {
        color: theme.palette.accent,
        outline: `1px solid ${theme.palette.accent}`,
        background: imgUrl
          ? `linear-gradient(0deg, var(--Black-50, rgba(0, 0, 0, 0.50)) 0%, var(--Black-50, rgba(0, 0, 0, 0.50)) 100%), url(${imgUrl})`
          : theme.palette.bgDark,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }),
    },
  }),
}));

export const HiddenInput = styled('input')({
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  border: 0,
});

export const StyledCrossIcon = styled(CloseIcon)(({ theme }) => ({
  borderRadius: '50%',
  top: 0,
  right: 0,
  position: 'absolute',
  backgroundColor: theme.palette.black_100,
  color: theme.palette.white_100,
  '&:hover': {
    color: theme.palette.accent,
  },
}));
